import type1 from '@/components/type_questions/type1'
import editor from '@/components/editor'
import type3 from '@/components/type_questions/type3'
import type4 from '@/components/type_questions/type4'

export default {
    data() {
        return {
            questionAnalytic: null
        }
    },
    created() {

    },
    mounted() {
        this.$TestApp.appendAudioControl()
    },
    components: {
        type1,
        editor,
        type3,
        type4
    },
    computed: {
        Questions(){
            return this.$TestApp.getQuestionOfPart()
        },
        partTitle() {
            return this.Questions.name
        },
    },
    filters: {
        secondToMinute(time) {
            const minute = parseInt(time / 60, 0) < 10 ? `0${parseInt(time / 60, 0)}` : parseInt(time / 60, 0)
            const secord = time % 60 < 10 ? `0${time % 60}` : time % 60
            return `${minute}:${secord}`
        },
    },
    methods: {
        formatSecondsAsTime(secs) {
            var hr  = Math.floor(secs / 3600);
            var min = Math.floor((secs - (hr * 3600))/60);
            var sec = Math.floor(secs - (hr * 3600) -  (min * 60));

            if (min < 10){ 
                min = "0" + min; 
            }
            if (sec < 10){ 
                sec  = "0" + sec;
            }

            return min + ':' + sec;
        },
        nextPartAction () {

            this.questionAnalytic = this.$TestApp.getPartAnalytic()

            this.$bvModal.show('confirm-next')
        },
        toggleNavClass(){
            if(this.navActive == false){
                return 'nav'
            } else {
                return 'sticky-nav'
            }
        },
    }
}